<script setup lang="ts">
import { ContractStatus } from "#imports"

defineProps<{
  status: ContractStatus
  creationDate?: Date | string
}>()

const badgeMap: Record<ContractStatus, { icon: string; color: string }> = {
  [ContractStatus.enum.no_status]: {
    icon: "i-fa6-solid-ban",
    color: "gray",
  },
  [ContractStatus.enum.connection_requested]: {
    icon: "i-fa6-solid-plug",
    color: "rnxblue",
  },
  [ContractStatus.enum.commissioned]: {
    icon: "i-fa6-solid-plug-circle-bolt",
    color: "rnxblue",
  },
  [ContractStatus.enum.contract_available]: {
    icon: "i-fa6-solid-paperclip",
    color: "rnxblue",
  },
  [ContractStatus.enum.signed]: {
    icon: "i-fa6-solid-signature",
    color: "rnxblue",
  },
  [ContractStatus.enum.countersigned]: {
    icon: "i-fa6-solid-file-contract",
    color: "rnxgreen",
  },
  [ContractStatus.enum.litigation]: {
    icon: "i-fa6-solid-file-contract",
    color: "red",
  },
  [ContractStatus.enum.form_filling]: {
    icon: "i-fa6-solid-file-pen",
    color: "red",
  },
  [ContractStatus.enum.under_verification]: {
    icon: "i-fa6-solid-check-double",
    color: "red",
  },
  [ContractStatus.enum.transferred]: {
    icon: "i-fa6-solid-arrow-right-arrow-left",
    color: "zinc",
  },
  [ContractStatus.enum.provisional]: {
    icon: "i-fa6-solid-hourglass-half",
    color: "amber",
  },
  [ContractStatus.Enum.vendu]: {
    icon: "i-fa6-regular-handshake",
    color: "rnxblue",
  },
  [ContractStatus.Enum.ended]: {
    icon: "i-heroicons-arrow-right-end-on-rectangle",
    color: "gray",
  },
  [ContractStatus.Enum.cancelled]: {
    icon: "i-fa7-regular-window-close",
    color: "gray",
  },
}
</script>

<template>
  <tippy>
    <Badge :color="badgeMap[status].color">
      <div class="inline-flex max-w-full items-center gap-x-2 rounded-md px-1">
        <UIcon :name="badgeMap[status].icon" />
        <span class="truncate text-xs font-semibold">{{ $t(`contract.status.${status}`) }}</span>
      </div>
    </Badge>
    <template #content>
      <div v-if="R.isNonNullish(creationDate)" class="text-sm">
        {{
          $t("time.created", {
            diff: diffToDuration(new Date(), creationDate),
            date: displayDate(creationDate),
          })
        }}
      </div>
      <div v-else>{{ $t(`contract.status.${status}`) }}</div>
    </template>
  </tippy>
</template>
